<template>
  <div>
    <div class="t-tab-container">
      <div class="t-tab-tabs">
        <span class="title">{{title}}</span>
        <template v-for="(tab,index) in tabList">
          <span
            @click="clickTab(index)"
            class="tab"
            :class="index==activeIndex?'active-tab':''"
            :key="tab"
          >{{tab}}</span>
        </template>
      </div>
      <div class="t-tab-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "tabList","activeCode"],
  data() {
    return {
      activeIndex: 0,
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch:{
    activeCode: {
      handler(newVal) {
        this.activeIndex = newVal
      },
      deep: true,
      // immediate: true,
    },
  },
  methods: {
    clickTab(index) {
      this.activeIndex = index;
      this.$emit("tabChange", index);
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped="">
.t-tab-container{}
.t-tab-tabs {
  height: 50px;
  border: 1px solid #e1e1e1;
  background: #f2f2f5;
}
.title {
  font-size: 18px;
  font-weight: bold;
  line-height: 50px;
  padding-left: 20px;
  margin-right: 30px;
}
.tab {
  font-size: 16px;
  line-height: 50px;
  display: inline-block;
  height: 100%;
  width: 100px;
  text-align: center;
  cursor: pointer;
}
.active-tab {
  border: 1px solid #e1e1e1;
  border-top: 0;
  border-bottom: 0;
  background: #fff;
  color: #e96b5a;
  position: relative;
  &:after {
    content: "";
    display: block;
    width: 20px;
    height: 2px;
    background: #e96b5a;
    position: absolute;
    bottom: 8px;
    left: calc(50% - 10px);
  }
}
.t-tab-content {
  height: 640px;
  position: relative;
}
</style>